<template>
  <!-- eslint-disable -->
  <lite-youtube
    :videoid="videoid"
    :playlabel="playlabel"
    :params="params"
  />
</template>

<script>
  import 'lite-youtube-embed';

  import 'lite-youtube-embed/src/lite-yt-embed.css';
  
  export default {
    name: 'LiteYoutubeEmbed',
    props: {
      videoid: String,
      playlabel: String,
      params: String,
    },
  }
</script>